<div (click)="toggleVisibility()" [ngClass]="getClasses()">
	<md-icon class="search" (click)="focusInput()">search</md-icon>
	<input [placeholder]="placeholder() ?? ''" #inputElement type="text" [value]="value || ''" (input)="onInputChange($event)" />

	@if (showClearButton) {
		<md-icon class="cancel" (click)="clear()">clear</md-icon>
	}
</div>
